import { render, staticRenderFns } from "./modalCadastroPregao.vue?vue&type=template&id=7be3b132"
import script from "./modalCadastroPregao.vue?vue&type=script&lang=js"
export * from "./modalCadastroPregao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports